import { Pipe, PipeTransform } from '@angular/core';
import { inRange } from 'lodash-es';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateValvePosition',
})
export class TranslateValvePositionPipe implements PipeTransform {
  private readonly motorPositionRanges = [
    {
      from: -Infinity,
      to: 5,
      value: 'closed',
    },
    {
      from: 6,
      to: 31,
      value: 'low',
    },
    {
      from: 31,
      to: 71,
      value: 'medium',
    },
    {
      from: 71,
      to: 91,
      value: 'high',
    },
    {
      from: 91,
      to: Infinity,
      value: 'open',
    },
  ];

  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: number): string {
    if (
      value !== undefined &&
      this.customTranslationsService.MOTOR_POSITION[this.description(value)]
    ) {
      return this.translateService.instant(
        this.customTranslationsService.MOTOR_POSITION[this.description(value)] ??
          this.description(value)
      );
    }

    return '';
  }

  private description(value: number): string {
    if (!value || isNaN(value)) {
      return 'closed';
    }

    if (value === Infinity) {
      return 'open';
    }

    const motorPositionRange = this.motorPositionRanges.find((range) =>
      inRange(value, range.from, range.to)
    );

    return motorPositionRange ? motorPositionRange.value : 'closed';
  }
}
